import React from "react";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SimpleHeader from "../components/SimpleHeader";

const SupportPage = () => {
  const navigate = useNavigate();
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src =
  //     "https://www.gstatic.com/dialogflow-console/fast/messenger/bootstrap.js?v=1";
  //   script.async = true;
  //   document.body.appendChild(script);
  // }, []);

  const handleNavigate = () => {
    navigate("/support-chat");
  };

  return (
    <>
      <SimpleHeader />
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Support
        </Typography>
        <Typography variant="body1" paragraph>
          Welcome to the FarmApp Support page. Here you can find answers to
          common questions, troubleshooting tips, and ways to contact us for
          further assistance.
        </Typography>
        <Typography variant="h5" gutterBottom>
          Need help?
        </Typography>
        <Button variant="contained" color="primary" onClick={handleNavigate}>
          Start a new chat
        </Button>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Frequently Asked Questions
        </Typography>
        <List>
          <ListItem>
            <ListItemText
              primary="How do I register for FarmApp?"
              secondary="You can register by downloading the app and following the signup process."
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="What services does FarmApp offer?"
              secondary="FarmApp provides soil testing insights, AI-powered crop advisory, blockchain traceability, and more."
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Is my data secure?"
              secondary="Yes, your data is handled in accordance with our Privacy Policy."
            />
          </ListItem>
        </List>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Technical Support
        </Typography>
        <Typography variant="body1" paragraph>
          If you are facing any technical issues, please try the following
          steps:
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="Ensure you have the latest version of the app installed." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Restart your device and relaunch the app." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Check your internet connection." />
          </ListItem>
        </List>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Contact Support
        </Typography>
        <Typography variant="body1" paragraph>
          If you need further assistance, feel free to reach out to our support
          team:
        </Typography>
        <Box sx={{ pl: 2 }}>
          <Typography variant="body1">Ms. Sonia Kapoor</Typography>
          <Typography variant="body1">
            Company Name: ASQI Investment Managers Private Limited
          </Typography>
          <Typography variant="body1">
            Address: H-532, Kanakia Zillion, BKC Annexe, Kurla West, Mumbai
            400070
          </Typography>
          <Typography variant="body1">Email: support@farmapp.in</Typography>
        </Box>
      </Container>
      <df-messenger
        intent="WELCOME"
        chat-title="FarmAppAssistant"
        agent-id="df03a6f6-c7f5-44e1-b311-d9f4804686fb"
        language-code="en"
      ></df-messenger>
    </>
  );
};

export default SupportPage;
